const CART_SELECTOR = '.js-header-cart';
const CART_UI_ACTIVE_CLASS = 'header-cart_active';
const CART_UI_INACTIVE_CLASS = 'header-cart_inactive';
const MIN_SCROLL_TO_DISPLAY = 600;
const PAGE = 'page';


var headerCart = document.querySelector(CART_SELECTOR);

if (headerCart) {
    window.addEventListener('scroll', function () {
        if (window.scrollY > MIN_SCROLL_TO_DISPLAY) headerCart.classList.add(CART_UI_ACTIVE_CLASS);
        else headerCart.classList.remove(CART_UI_ACTIVE_CLASS);
    });
}


